<template>
  <div class="custom-font-regular">
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{ toolbarTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-md mt-5 pt-5>
      <template v-if="isSettlementTV">
        <v-alert :value="true" type="success" icon="check_circle_outline" class="custom-alert custom-font-regular"
                 v-if="communication.estado === 'Aprobada'">Liquidación Aprobada</v-alert>
        <v-alert :value="true" type="error" icon="highlight_off" class="custom-alert custom-font-regular"
                 v-if="communication.estado === 'Rechazada'">Liquidación Rechazada</v-alert>
        <v-alert :value="true" type="warning" icon="help_outline" class="custom-alert custom-font-regular"
                 v-if="communication.estado === 'Pendiente'">Liquidación Pendiente</v-alert>
      </template>
      <div v-if="loading">
        <v-flex offset-xs5 pa-5>
          <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
        </v-flex>
      </div>
      <div v-else>
        <v-toolbar class="header-element">
          <v-toolbar-title>{{ communication.title }}</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-layout row wrap>
            <v-flex :sm6="!period" :sm3="period" xs12>
              <v-subheader>Fecha</v-subheader>
              <v-card-title>{{ communication.fecha }}</v-card-title>
            </v-flex>
            <template v-if="$vuetify.breakpoint.smAndUp"><v-divider vertical></v-divider></template>
            <template v-else><v-flex ma-1 pa-0><v-divider></v-divider></v-flex></template>
            <template v-if="period">
              <v-flex sm3 xs12>
                <v-subheader>Período</v-subheader>
                <v-card-title>{{ communication.period }}</v-card-title>
              </v-flex>
              <template v-if="$vuetify.breakpoint.smAndUp"><v-divider vertical></v-divider></template>
              <template v-else><v-flex ma-1 pa-0><v-divider></v-divider></v-flex></template>
            </template>
            <v-flex v-if="!typeLabelHide" :sm5="!period" :sm4="period" xs12>
              <v-subheader>{{ typeLabel }}</v-subheader>
              <v-card-title>{{ communication.communicationType || communication.settlementType }}</v-card-title>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-subheader>{{ descripionLabel }}</v-subheader>
          <v-card-title>
            <pre class="communication-description custom-font-regular">{{ communication.description }}</pre>
          </v-card-title>
          <template v-if="communication.assets.length > 0">
            <v-divider></v-divider>
            <v-subheader>Adjuntos</v-subheader>
            <v-card-text v-for="asset in communication.assets" :key="asset.pk" class="pt-2">
              <a :href="asset.url" target="_blank">{{ getAttachmentName(asset.name) }}</a>
              <span v-if="asset.description" class="grey--text">: <i>{{ asset.description }}</i></span>
            </v-card-text>
          </template>
        </v-card>
        <BoletinRecipientsView v-if="isSafRole" :clubs="communication.clubes" :emails="communication.emails"
                               :person-criteria="communication.personCriteria"
                               :grupos="communication.grupos">
        </BoletinRecipientsView>
        <ResponseView v-if="isSettlementTV" :settlement="communication"
                      @updateAfterRequest="updateSettlementComments">
        </ResponseView>
        <GoBackButton/>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BoletinRecipientsView from '../components/BoletinRecipientsView'
import ResponseView from '../components/ResponseView'
import GoBackButton from '../../../common/ui/GoBackButton'

export default {
  props: {
    fetchPath: {
      type: String,
      default: 'bulletin'
    },
    toolbarTitle: {
      type: String,
      default: 'Comunicación'
    },
    typeLabel: {
      type: String,
      default: 'Tipo de comunicación'
    },
    typeLabelHide: {
      type: Boolean,
      default: false
    },
    descripionLabel: {
      type: String,
      default: 'Descripción'
    },
    period: Boolean
  },

  components: {
    BoletinRecipientsView,
    ResponseView,
    GoBackButton
  },

  data () {
    return {
      loading: false,
      communication: {},
      comments: {}
    }
  },

  computed: {
    ...mapGetters(['isSafRole', 'role']),
    isSettlementTV () {
      return this.communication.hasOwnProperty('settlementComments')
    }
  },

  methods: {
    getAttachmentName (attachment) {
      return attachment.split('/').slice(-1).pop()
    },
    fetchData () {
      this.loading = true
      this.axios
        .get(`${this.fetchPath}/${this.$route.params.id}`)
        .then(response => {
          this.communication = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    updateSettlementComments () {
      this.fetchData()
    }
  },

  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
.header-element {
  background-color: #293968;
  color: white;
}
pre {
  line-height: 1.5;
}
.communication-description {
  white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
  white-space: -pre-wrap; /* Opera */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
  word-wrap: break-word; /* IE 5.5+ */
  width: 100%;
}
</style>
